import { useIntlLight } from './libs/i18n';

export enum ROLE {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_MAPAQ = 'ROLE_MAPAQ',
  ROLE_MAPAQ_RO = 'ROLE_MAPAQ_RO',
  ROLE_SUPPORT = 'ROLE_SUPPORT',
  ROLE_SUPPORT_RO = 'ROLE_SUPPORT_RO',
  ROLE_DETENTEUR_PERMIS = 'ROLE_DETENTEUR_PERMIS',
  ROLE_VET = 'ROLE_VET',
  ROLE_FMV = 'ROLE_FMV',
  ROLE_PRODUCER = 'ROLE_PRODUCER',
  ROLE_ASSOCIATION = 'ROLE_ASSOCIATION',
  ROLE_VET_SOFTWARE_SUPPLIER = 'ROLE_VET_SOFTWARE_SUPPLIER',
  ROLE_IMPORTATION_PERMIS = 'ROLE_IMPORTATION_PERMIS',
  ROLE_USER = 'ROLE_USER',
}

export const ROUTE = {
  declaration: {
    api: '/api/declarations',
    apiSiteUpdate: '/api/declarations/site_update',
    queryKey: 'declarations',
    pathSiteUpdate: 'declaration_site_update',
  },
  epqAccessRequest: {
    api: '/api/epq_access_requests',
    queryKey: 'epq_access_requests',
    path: 'request_access',
    formPath: 'request_access_form',
    organization: '/organization/request_access',
    producer: '/producer/request_access',
    users: (id: string | number) => `/producer/request_access/${id}/users`,
    userDetail: (id: string | number, userId: string | number) =>
      `/producer/request_access/${id}/users/${userId}/detail`,
  },
  epqRequestDivision: {
    api: '/api/epq_request_divisions',
    queryKey: 'epq_request_divisions',
    path: 'epq_request_division',
  },
  epqRequestSite: {
    api: '/api/epq_request_sites',
    queryKey: 'epq_request_sites',
    path: 'epq_request_site',
  },
  epqRequestUserAccess: {
    api: '/api/epq_request_user_accesses',
    queryKey: 'epq_request_user_accesses',
  },
  epqRequestUserAccessDetail: {
    api: '/api/epq_request_user_access_details',
    queryKey: 'epq_request_user_access_details',
  },
  finalAddress: {
    api: '/api/final_addresses',
    queryKey: 'final_addresses',
    path: 'final_address',
  },
  ingredientFamily: {
    api: '/api/ingredient_families',
    queryKey: 'ingredient_families',
    path: 'ingredient_family',
  },
  medication: {
    api: '/api/medications',
    queryKey: 'getAllMedication',
    path: 'medication',
    view: (id: string | number) => `/medication/${id}`,
  },
  medicationImport: {
    api: '/api/medication_imports',
    queryKey: 'medication_imports',
  },
  permit: {
    api: '/api/permits',
    queryKey: 'permits',
    path: 'permit',
    view: (id: string | number) => `/permit/${id}`,
  },
  permitCode: {
    api: '/api/permit_codes',
    queryKey: 'permit_codes',
    path: 'permit_code',
  },
  permitStatusHistory: {
    api: '/api/permit_status_histories',
    queryKey: 'permit_status_histories',
  },
  regulationDateLimit: {
    api: '/api/regulation_date_limits',
    queryKey: 'regulation_date_limits',
    path: 'regulation_date_limit',
  },
  routeOfAdministration: {
    api: '/api/route_of_administrations',
    queryKey: 'route_of_administrations',
    path: 'route_of_administration',
  },
  species: {
    api: '/api/species',
    queryKey: 'species',
  },
  statistics: {
    api: '/api/statistics',
  },
  userAccount: {
    api: '/api/user_accounts',
    queryKey: 'user_accounts',
    path: 'users',
  },
  userApiKey: {
    api: '/api/user_api_keys',
    queryKey: 'user_api_keys',
    path: 'user_api_key',
    apiCreators: '/api/user_api_keys/users/creators',
    queryKeyCreators: 'user_api_keys_creators',
  },
  veterinarian: {
    dashboard: {
      pathVeterinarian: '/dashboard/veterinarian',
      pathPrescriptionSummary: '/dashboard/veterinarian_prescription_summary',
      pathProducerShort: 'veterinarian_producer',
      pathProducer: `/dashboard/veterinarian_producer`,
      pathProducerPurchaseSummaryShort: 'veterinarian_producer_purchase_summary',
      pathProducerPurchaseSummary: '/dashboard/veterinarian_producer_purchase_summary',
    },
  },
  login: '/login',
  home: '/',
};

export const LINK = {
  accesporcIntro: 'https://accesporcqc.ca/php/producteur/antibiotiqc/gestion_autorisations.php',
  attestraApiDev: 'https://api-monitorage-demo.attestra.com/api/docs',
  attestraApiProd: 'https://api-antibiotiqc.attestra.com/api/docs',
  attestraCustomer: 'https://attestra.atlassian.net/servicedesk/customer/portal/4/group/16',
  attestraDemo: 'https://monitorage-demo.attestra.com',
  attestraFaq:
    'https://attestra.com/solutions-technologiques/monitorage-des-antibiotiques/foire-aux-questions-aide',
  attestraMonitoringDev:
    'https://monitorage-demo.attestra.com/docs/Donnees_recoltees_Reglement_20251215.pdf',
  attestraMonitoringProd:
    'https://antibiotiqc.attestra.com/docs/Donnees_recoltees_Reglement_20251215.pdf',
  attestraRequestManagementPortal: 'https://soutien-antibiotiqc.attestra.com',
  attestraTraining:
    'https://attestra.com/solutions-technologiques/monitorage-des-antibiotiques/guides-et-tutoriels',
  healthCanadaCategorization:
    'https://www.canada.ca/fr/sante-canada/services/medicaments-produits-sante/medicaments-veterinaires/resistance-antimicrobiens/categorisation-medicaments-antimicrobiens-basee-leur-importance-medecine-humaine.html',
  legisQuebecA2: 'https://www.legisquebec.gouv.qc.ca/fr/document/lc/A-2.1',
  legisQuebecP42R10: 'https://www.legisquebec.gouv.qc.ca/fr/document/rc/P-42,%20r.%2010%20',
  mapaqAntibioDoc:
    'https://www.quebec.ca/agriculture-environnement-et-ressources-naturelles/sante-animale/usage-antibiotiques/reglementation',
  mapaqMonitoring:
    'https://www.quebec.ca/agriculture-environnement-et-ressources-naturelles/sante-animale/usage-antibiotiques/surveillance#c333383',
  mapaqPermit: 'https://web.mapaq.gouv.qc.ca/bh/etablissements-sous-permis',
  microsoftLogin: 'https://login.microsoftonline.com/',
};

export const IMG = {
  logo: '/image/Logo_AntibiotiQC.png',
};

export const MAILTO = {
  epqAntibio: 'mailto:antibiotiques@leseleveursdeporcs.quebec',
  mapaqAntibioQc: 'mailto:AntibiotiQC@mapaq.gouv.qc.ca',
  mapaqInfo: 'mailto:accesinformation@mapaq.gouv.qc.ca',
};

export const PUBLIC_PATHS = [
  '/login',
  '/login_callback',
  '/logout',
  '/logout_callback',
  '/404',
  '/500',
];

export interface InlineAddress {
  firstLine: string;
  secondLine?: string;
  city: string;
  postalCode: string;
  countrySubdivision: string;
  ADDRESS_TYPE: 'INLINE';
}

export interface DetailedAddress {
  civicNumber: string;
  unitNumber: string;
  streetName: string;
  ruralRoute?: string;
  poBox?: string;
  stationInformation?: string;
  city: string;
  province: string;
  postalCode: string;
  countrySubdivision: string;
  ADDRESS_TYPE: 'DETAILED';
}

export interface GeoAddress {
  addressFirst: string;
  city: string;
  province: string;
  country: string;
  postalCode: string;
}

export enum Notices {
  TRANSACTIONS_DECLARATION_NOTICE = 'TRANSACTIONS_DECLARATION_NOTICE',
  ADD_SITE_NOTICE = 'ADD_SITE_NOTICE',
}

export enum UserProfile {
  VETERINARIAN = 'veterinarian',
  PRODUCER = 'producer',
  PERMIT_OWNER = 'permitOwner',
}

export enum DeclarationType {
  SALE_SUPPLY = 'SALE_SUPPLY',
  RETURN = 'RETURN',
}

export enum UseTermType {
  UTILISATEUR = 'UTILISATEUR',
}

export enum RegulationDateLimitType {
  GLOBAL = 'GLOBAL',
  ANNUAL = 'ANNUAL',
}

export enum OmvqEstablishmentUserType {
  NOT_VET = 'NOT_VET',
  OWNER = 'OWNER',
  VET = 'VET',
}

export enum RequestUserAccessLevel {
  MANAGER = 'MANAGER',
  OWNER = 'OWNER',
  USER = 'USER',
  VET = 'VET',
}

export enum RequestStatus {
  SENT = 'SENT',
  IN_PROGRESS = 'IN_PROGRESS',
  CANCELED = 'CANCELED',
  REFUSED = 'REFUSED',
  ACCEPTED = 'ACCEPTED',
}

export enum RequestStatusDetail {
  BY_OWNER = 'BY_OWNER',
  ERROR = 'ERROR',
  OWNER_CHANGE = 'OWNER_CHANGE',
  REMOVED_CONSENT = 'REMOVED_CONSENT',
  REMOVED_CONSENT_BY_ORG = 'REMOVED_CONSENT_BY_ORG',
}

export enum TokenType {
  ACCESS_TOKEN = 'access_token',
  ACCESS_TOKEN_SSO = 'access_token_sso',
  REFRESH_TOKEN = 'refresh_token',
  REFRESH_TOKEN_SSO = 'refresh_token_sso',
}

export enum HttpHeader {
  USE_CUSTOM_AUTHORIZATION = 'UseCustomAuthorization',
  X_SWITCH_USER = 'X-Switch-User',
  X_SWITCH_TOKEN = 'X-Switch-Token',
}

export enum HttpHeaderValue {
  AUTHORIZATION_SSO = 'Authorization',
  AUTHORIZATION_ATTESTRA_CONNECT = 'Authorizationattestraconnect',
}

export enum HttpStatusCode {
  USER_NOT_CREATED = 424,
  USER_NOT_FOUND = 404,
  ATTESTRA_USER_WITHOUT_ACCOUNT = 428,
  UNAUTHORIZED = 401,
}

export enum ValidationStatus {
  APPROVED = 'APPROVED',
  PENDING_APPROVAL_FMV = 'PENDING_APPROVAL_FMV',
  PENDING_APPROVAL_MAPAQ = 'PENDING_APPROVAL_MAPAQ',
}

export enum VeterinarianStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  INACTIVE_18_MONTH = 'INACTIVE_18_MONTH',
  SUSPENDED = 'SUSPENDED',
}

export enum MedicationClass {
  VET = 'Vétérinaire',
  HUMAN = 'Humain',
}

export enum IngredientStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export const SPECIES_SINGLE_SELECT_EXCLUDE_CODES = [
  'BOV',
  'CAP',
  'EQU',
  'LAP',
  'OVI',
  'POI',
  'VOL',
  'AUT',
  'FELIN',
  'CANIN',
  'CER',
];

export const ROMAN_MAP: Record<string, string> = { '1': 'I', '2': 'II', '3': 'III', '4': 'IV' };

export type IntlLightT = ReturnType<typeof useIntlLight>['t'];
